import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { requireAccountDeletionAnonymousSession } from "../services/accountDeletionAnonymousSession";

export const useAccountDeletionAnonymousSession = () => {
    const dispatch = useDispatch();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        let active = true;
        const prepareAnonymousSession = async () => {
            try {
                await requireAccountDeletionAnonymousSession(dispatch);
                if (active) {
                    setIsReady(true);
                }
            } catch (_) {
                // Fail closed: HttpOnly auth or SSO-state cookies may remain.
            }
        };
        void prepareAnonymousSession();
        return () => {
            active = false;
        };
    }, [dispatch]);

    return isReady;
};
